<template>
  <form
    class="new-payroll"
    @submit.prevent="create"
  >
    <div class="columns is-multiline">
      <div class="column is-6">
        <PayrollDetails
          :loading="loading"
          :disabled="loading"
        />
      </div>
      <div class="column is-6">
        <PayrollReceiver
          :loading="loading"
          :disabled="loading"
        />
      </div>
      <div class="column is-12">
        <PayrollPercepts
          :loading="loading"
          :disabled="loading"
        />
      </div>
      <div class="column is-12">
        <PayrollDeductions
          :loading="loading"
          :disabled="loading"
        />
      </div>
      <div class="column is-12">
        <PayrollOtherPayments
          :loading="loading"
          :disabled="loading"
        />
      </div>
      <div class="column is-12">
        <PayrollPaidLeaves
          :loading="loading"
          :disabled="loading"
        />
      </div>
    </div>
    <div
      v-observe-visibility="onTotalsVisibleChange"
      class="action-buttons is-flex"
    >
      <div
        class="box totals wrapper-payroll-totals"
        :class="{ 'totals-is-not-visible has-background-info': !totalsIsVisible }"
      >
        <div class="columns is-multiline">
          <div
            class="column"
            :class="[totalsIsVisible ? 'is-6' : 'is-narrow']"
          >
            <h4
              class="title is-5"
              :class="[totalsIsVisible ? 'has-text-primary' : 'has-text-white']"
            >
              Sueldo bruto:
            </h4>
          </div>
          <div
            class="column"
            :class="[totalsIsVisible ? 'is-6 has-text-primary' : 'is-narrow has-text-white']"
          >
            {{ $store.getters['payroll/subtotal'] | toCurrency }}
          </div>
          <div
            class="column"
            :class="[totalsIsVisible ? 'is-6' : 'is-narrow']"
          >
            <h4
              class="title is-5"
              :class="[totalsIsVisible ? 'has-text-primary' : 'has-text-white']"
            >
              Deducciones:
            </h4>
          </div>
          <div
            class="column"
            :class="[totalsIsVisible ? 'is-6 has-text-primary' : 'is-narrow has-text-white']"
          >
            {{ $store.getters['payroll/taxes'] | toCurrency }}
          </div>
          <div
            class="column"
            :class="[totalsIsVisible ? 'is-6' : 'is-narrow']"
          >
            <h4
              class="title is-5"
              :class="[totalsIsVisible ? 'has-text-primary' : 'has-text-white']"
            >
              Sueldo neto:
            </h4>
          </div>
          <div
            class="column"
            :class="[totalsIsVisible ? 'is-6 has-text-primary' : 'is-narrow has-text-white']"
          >
            {{ $store.getters['payroll/total'] | toCurrency }}
          </div>
        </div>
      </div>
      <div class="field is-grouped">
        <p class="control">
          <button
            class="button is-success"
            :class="{ 'is-loading': loading }"
            type="submit"
            :disabled="loading"
          >
            Generar Nómina
          </button>
        </p>
        <p class="control">
          <RouterLink
            class="button is-danger"
            :class="{ 'is-loading': loading }"
            :disabled="loading"
            :to="{ name: 'Home' }"
          >
            Cancelar
          </RouterLink>
        </p>
      </div>
    </div>
    <RouterView />
  </form>
</template>

<script>
function watch() {
  const { dailyBaseSalary } = this.$store.state.employee;
  const { earnedDays, percepts } = this.$store.state.payroll;

  if (earnedDays && dailyBaseSalary) {
    const perceptSalaryIndex = percepts.findIndex(({ perceptType }) => (perceptType === '001'));
    if (perceptSalaryIndex >= 0) {
      this.$store.commit('payroll/changePercept', {
        index: perceptSalaryIndex,
        name: 'taxedAmount',
        value: parseFloat(earnedDays) * parseFloat(dailyBaseSalary),
      });
    } else {
      this.$store.commit('payroll/changePercept', {
        index: 0,
        name: 'perceptType',
        value: '001',
      });

      this.$store.commit('payroll/changePercept', {
        index: 0,
        name: 'taxedAmount',
        value: parseFloat(earnedDays) * parseFloat(dailyBaseSalary),
      });
    }
  }
}

export default {
  name: 'NewPayroll',
  components: {
    PayrollDetails: () => import(/* webpackChunkName: "payroll-details" */ '@/components/Admin/Payroll/PayrollDetails.vue'),
    PayrollReceiver: () => import(/* webpackChunkName: "payroll-receiver" */ '@/components/Admin/Payroll/PayrollReceiver.vue'),
    PayrollPercepts: () => import(/* webpackChunkName: "payroll-percepts" */ '@/components/Admin/Payroll/PayrollPercepts.vue'),
    PayrollDeductions: () => import(/* webpackChunkName: "payroll-deductions" */ '@/components/Admin/Payroll/PayrollDeductions'),
    PayrollOtherPayments: () => import(/* webpackChunkName: "payroll-other-payments" */ '@/components/Admin/Payroll/PayrollOtherPayments.vue'),
    PayrollPaidLeaves: () => import(/* webpackChunkName: "payroll-paid-leaves" */ '@/components/Admin/Payroll/PayrollPaidLeaves.vue'),
  },
  data() {
    return {
      loading: false,
      totalsIsVisible: false,
    };
  },
  watch: {
    '$store.state.payroll.earnedDays': watch,
    '$store.state.employee.dailyBaseSalary': watch,
  },
  async beforeDestroy() {
    window.location.reload();
  },
  methods: {
    async create() {
      if (!this.$store.state.employee.id) {
        this.$warning({ message: 'Necesitas seleccionar un empleado' });
      }

      this.loading = true;
      try {
        await this.$store.dispatch('payroll/create');
        this.$router.push({ name: 'PayrollsList' });
        this.$success({ message: 'Nómina creada con exito' });
      } catch (error) {
        this.$danger({ message: error.message });
      }
      this.loading = false;
    },
    onTotalsVisibleChange(isVisible) {
      this.totalsIsVisible = isVisible;
    },
  },
};
</script>

<style scoped>
.action-buttons {
  flex-direction: column;
  align-items: flex-end;
}

.new-payroll {
  padding: 1rem;
  margin-bottom: 6rem;
}

.totals {
  padding: 1.5rem;
}

.totals:not(.totals-is-not-visible) {
  padding: 2rem;
}

.totals .column:not(:last-child) {
  padding: 0 0 .5rem 0;
}

.totals .column:nth-last-child(2),
.totals .column:last-child {
  padding: 0;
}

.totals-is-not-visible {
  bottom: 4px;
  overflow: hidden;
  position: fixed;
  right: 95px;
  z-index: 2;
}

.totals.totals-is-not-visible .column {
  padding: 0 1rem 0 0;
}
</style>
